import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useAnalytics from "hooks/useAnalytics";

import { AiIntegrationView } from "../../../useSearchAiIntegrations/gql";
import AiIntegrationsActionsDropdown from "../../ActionsDropdown";

const REFETCH_QUERIES = ["SearchAiIntegrations"];

const IntegrationsAiTableDropdownActionsCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AiIntegrationView>) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimpleCell {...cellProps}>
      <AiIntegrationsActionsDropdown
        integration={item}
        trackAnalytics={trackAnalytics}
        refetchQueriesOnEdit={REFETCH_QUERIES}
        refetchQueriesOnDelete={REFETCH_QUERIES}
      />
    </TableSimpleCell>
  );
};

export default IntegrationsAiTableDropdownActionsCell;
